// Dependencies
import React, { Component } from 'react';
import HostingInfo from '../../subcomponents/HostingInfo';
import image from '../../assets/img/vector/hosting_enterprise.svg';
import cpanel_logo from '../../assets/img/cpanel.svg';
import Section from '../../layout/Section';
import SectionContainer from '../../subcomponents/SectionContainer';
import ImageText from '../../subcomponents/ImageText';

import hosting1 from '../../assets/img/flat/hosting1.svg';
import hosting2 from '../../assets/img/flat/hosting2.svg';
import hosting3 from '../../assets/img/flat/hosting3.svg';
import IconBlock28 from '../../subcomponents/IconBlock28';

// Branding
import cloudlinux from '../../assets/img/brand/cloudlinux.png';
import cpanel from '../../assets/img/brand/cpanel.svg';
import ceph from '../../assets/img/brand/ceph.png';

// Opciones
import settings from '../../assets/img/settings.svg';
import lock from '../../assets/img/lock.svg';
import firewall from '../../assets/img/firewall.svg';
import php from '../../assets/img/php.svg';
import backup from '../../assets/img/backup.svg';
import monitor from '../../assets/img/monitor.svg';
import FormularioContactoModal from '../../subcomponents/FormularioContactoModal';

class HostingEnterprise extends Component {
  constructor(props) {
    super(props);
    this.state = { hostingInfo: {}, modalAsunto: 'Contacto' };
  }
  componentDidMount() {
    document.title = 'Hosting Enterprise - Insacom';
    /* eslint-disable */
    $.HSCore.components.HSModalWindow.init('[data-modal-target]');
  }

  changeHostingInfo(data) {
    this.setState({ hostingInfo: data });
  }

  render() {
    const iconBlocks = [
      {
        id: 1,
        title: 'Máximo Rendimiento',
        description: 'Contamos con servidores optimizados para lograr una Performace insuperable',
        img: hosting1
      },
      {
        id: 2,
        title: 'Seguridad',
        description: 'Todos nuestros planes cuentan con certificados SSL Gratuitos',
        img: hosting2
      },
      {
        id: 3,
        title: 'Alta Disponibilidad',
        description:
          'Nuestros servidores cuentan con una configuración de Alta Disponibilidad para que tu negocio tenga la estabilidad que necesita',
        img: hosting3
      }
    ];

    const hostingDataMensual = [
      {
        id: 6,
        title: 'Bronze',
        desc: (
          <em className="g-font-style-normal">
            <b>30GB</b> Espacio
          </em>
        ),
        price: '1 UF',
        paymentType: 'Mes + IVA',
        info: [
          <li className="g-brd-bottom g-brd-gray-light-v4 g-py-6">
            <i className="fa fa-star g-color-yellow"></i> IP Dedicada
          </li>,
          <li className="g-brd-bottom g-brd-gray-light-v4 g-py-6">
            Tráfico <b>Ilimitado</b>
          </li>,
          <li className="g-brd-bottom g-brd-gray-light-v4 g-py-6">
            <i className="g-color-primary fa fa-lock"></i> Certificado SSL
          </li>,
          <li className="g-brd-bottom g-brd-gray-light-v4 g-py-6">Setup Gratis</li>,
          <li className="g-brd-bottom g-brd-gray-light-v4 g-py-6">Cuentas de Correo Ilimitadas</li>,
          <li className="g-brd-bottom g-brd-gray-light-v4 g-py-6">
            <img src={cpanel_logo} style={{ height: '15px' }}></img>
          </li>,
          <li className="g-brd-bottom g-brd-gray-light-v4 g-py-6">Backup Diario</li>
        ],
        buttonText: 'Contratar'
      },
      {
        id: 7,
        title: 'Silver',
        desc: (
          <em className="g-font-style-normal">
            <b>40GB</b> Espacio
          </em>
        ),
        price: '1.5 UF',
        paymentType: 'Mes + IVA',
        info: [
          <li className="g-brd-bottom g-brd-gray-light-v4 g-py-6">
            <i className="fa fa-star g-color-yellow"></i> IP Dedicada
          </li>,
          <li className="g-brd-bottom g-brd-gray-light-v4 g-py-6">
            Tráfico <b>Ilimitado</b>
          </li>,
          <li className="g-brd-bottom g-brd-gray-light-v4 g-py-6">
            <i className="g-color-primary fa fa-lock"></i> Certificado SSL
          </li>,
          <li className="g-brd-bottom g-brd-gray-light-v4 g-py-6">Setup Gratis</li>,
          <li className="g-brd-bottom g-brd-gray-light-v4 g-py-6">Cuentas de Correo Ilimitadas</li>,
          <li className="g-brd-bottom g-brd-gray-light-v4 g-py-6">
            <img src={cpanel_logo} style={{ height: '15px' }}></img>
          </li>,
          <li className="g-brd-bottom g-brd-gray-light-v4 g-py-6">Backup Diario</li>
        ],
        buttonText: 'Contratar'
      },
      {
        id: 8,
        title: 'Gold',
        desc: (
          <em className="g-font-style-normal">
            <b>60GB</b> Espacio
          </em>
        ),
        price: '2 UF',
        paymentType: 'Mes + IVA',
        info: [
          <li className="g-brd-bottom g-brd-gray-light-v4 g-py-6">
            <i className="fa fa-star g-color-yellow"></i> IP Dedicada
          </li>,
          <li className="g-brd-bottom g-brd-gray-light-v4 g-py-6">
            Tráfico <b>Ilimitado</b>
          </li>,
          <li className="g-brd-bottom g-brd-gray-light-v4 g-py-6">
            <i className="g-color-primary fa fa-lock"></i> Certificado SSL
          </li>,
          <li className="g-brd-bottom g-brd-gray-light-v4 g-py-6">Setup Gratis</li>,
          <li className="g-brd-bottom g-brd-gray-light-v4 g-py-6">Cuentas de Correo Ilimitadas</li>,
          <li className="g-brd-bottom g-brd-gray-light-v4 g-py-6">
            <img src={cpanel_logo} style={{ height: '15px' }}></img>
          </li>,
          <li className="g-brd-bottom g-brd-gray-light-v4 g-py-6">Backup Diario</li>
        ],
        buttonText: 'Contratar'
      },
      {
        id: 9,
        title: 'Platinum',
        desc: (
          <em className="g-font-style-normal">
            <b>100GB</b> Espacio
          </em>
        ),
        price: '2.5 UF',
        paymentType: 'Mes + IVA',
        info: [
          <li className="g-brd-bottom g-brd-gray-light-v4 g-py-6">
            <i className="fa fa-star g-color-yellow"></i> IP Dedicada
          </li>,
          <li className="g-brd-bottom g-brd-gray-light-v4 g-py-6">
            Tráfico <b>Ilimitado</b>
          </li>,
          <li className="g-brd-bottom g-brd-gray-light-v4 g-py-6">
            <i className="g-color-primary fa fa-lock"></i> Certificado SSL
          </li>,
          <li className="g-brd-bottom g-brd-gray-light-v4 g-py-6">Setup Gratis</li>,
          <li className="g-brd-bottom g-brd-gray-light-v4 g-py-6">Cuentas de Correo Ilimitadas</li>,
          <li className="g-brd-bottom g-brd-gray-light-v4 g-py-6">
            <img src={cpanel_logo} style={{ height: '15px' }}></img>
          </li>,
          <li className="g-brd-bottom g-brd-gray-light-v4 g-py-6">Backup Diario</li>
        ],
        buttonText: 'Contratar'
      }
    ];

    const hostingInfoMensual = [
      {
        title: 'Bronze',
        hosting_data: {
          'Espacio': '30GB',
          'Tráfico': 'Ilimitado',
          'Setup': 'Gratis',
          'Bases de Datos': 'Ilimitadas',
          'Cuentas de Correo': 'Ilimitadas',
          'Cuentas FTP': 'Ilimitadas',
          'Listas de Correo': 'Ilimitadas',
          'Sub Dominios': 'Ilimitados',
          'Dominios': 10,
          'Cpanel': 'check',
          'Webmail': 'check',
          'Anti Spam': 'check',
          'Google Apps Wizard': 'check',
          'Firewall': 'check'
        }
      },
      {
        title: 'Silver',
        hosting_data: {
          'Espacio': '40GB',
          'Tráfico': 'Ilimitado',
          'Setup': 'Gratis',
          'Bases de Datos': 'Ilimitadas',
          'Cuentas de Correo': 'Ilimitadas',
          'Cuentas FTP': 'Ilimitadas',
          'Listas de Correo': 'Ilimitadas',
          'Sub Dominios': 'Ilimitados',
          'Dominios': 10,
          'Cpanel': 'check',
          'Webmail': 'check',
          'Anti Spam': 'check',
          'Google Apps Wizard': 'check',
          'Firewall': 'check'
        }
      },
      {
        title: 'Gold',
        hosting_data: {
          'Espacio': '60GB',
          'Tráfico': 'Ilimitado',
          'Setup': 'Gratis',
          'Bases de Datos': 'Ilimitadas',
          'Cuentas de Correo': 'Ilimitadas',
          'Cuentas FTP': 'Ilimitadas',
          'Listas de Correo': 'Ilimitadas',
          'Sub Dominios': 'Ilimitados',
          'Dominios': 10,
          'Cpanel': 'check',
          'Webmail': 'check',
          'Anti Spam': 'check',
          'Google Apps Wizard': 'check',
          'Firewall': 'check'
        }
      },
      {
        title: 'Platinum',
        hosting_data: {
          'Espacio': '100GB',
          'Tráfico': 'Ilimitado',
          'Setup': 'Gratis',
          'Bases de Datos': 'Ilimitadas',
          'Cuentas de Correo': 'Ilimitadas',
          'Cuentas FTP': 'Ilimitadas',
          'Listas de Correo': 'Ilimitadas',
          'Sub Dominios': 'Ilimitados',
          'Dominios': 20,
          'Cpanel': 'check',
          'Webmail': 'check',
          'Anti Spam': 'check',
          'Google Apps Wizard': 'check',
          'Firewall': 'check'
        }
      }
    ];

    const descripcion =
      'Contamos con una amplia variedad de planes de hosting para tu proyecto, alojado en datacenter propio.';

    return (
      <Section no-contact>
        <SectionContainer paddingBottom={'0px'} backgroundColor="#f8c62a">
          <ImageText image={image} title="Hosting Enterprise" description={descripcion}>
            <div className="d-flex justify-content-around flex-wrap">
              <div className="align-self-center">
                <img src={cpanel} alt="CPanel" style={{ height: '36px' }}></img>
              </div>
              <div className="align-self-center">
                <img src={ceph} alt="CEPH" style={{ height: '80px' }}></img>
              </div>
              <div className="align-self-center">
                <img src={cloudlinux} alt="Cloud Linux" style={{ height: '80px' }}></img>
              </div>
            </div>
          </ImageText>
        </SectionContainer>
        <SectionContainer>
          <IconBlock28 content={iconBlocks}></IconBlock28>
        </SectionContainer>
        <SectionContainer grey>
          <div className="g-mt-50 text-center text-uppercase u-heading-v6-1 g-mb-20">
            <h2 className="h3 u-heading-v6__title">Planes Hosting para Empresas</h2>
            <p>El Hosting ideal para cubrir todas tus necesidades</p>
          </div>
          <div className="row align-items-center">
            {hostingDataMensual &&
              hostingDataMensual.map((hosting, key) => (
                <div key={key} className="col-md-3 g-mb-30">
                  <article className="g-bg-white text-center g-brd-around g-pa-10">
                    <div className="g-pa-30">
                      <h4 className="text-uppercase g-color-gray-dark-v3 g-font-weight-500 g-mb-10">
                        {hosting.title}
                      </h4>
                      {hosting.desc}
                      <hr className="g-brd-gray-light-v4 g-my-10"></hr>
                      <div className="g-color-primary g-my-20">
                        <div className="d-block g-font-size-30 g-line-height-1_2">
                          {hosting.price}
                        </div>{' '}
                        {hosting.paymentType}
                      </div>
                      <hr className="g-brd-gray-light-v4 g-mt-10 mb-0"></hr>
                      <ul className="list-unstyled g-mb-25">
                        {hosting.info &&
                          hosting.info.map((info, key) => <div key={key}>{info}</div>)}
                        <li className="g-brd-bottom g-brd-gray-light-v4 g-py-6">
                          <a
                            className="btn btn-sm u-btn-outline-teal"
                            onClick={() => this.changeHostingInfo(hostingInfoMensual[key])}
                            data-modal-target="#hosting-modal"
                            data-modal-effect="slide">
                            Ver más
                          </a>
                        </li>
                      </ul>
                      <button
                        data-modal-target="#contacto-modal"
                        onClick={() => {
                          this.setState({ modalAsunto: 'Hosting Empresa ' + hosting.title })
                        }}
                        className="btn text-uppercase u-btn-primary g-rounded-50 g-font-size-12 g-font-weight-700 g-pa-15-30">
                        {hosting.buttonText}
                      </button>
                    </div>
                  </article>
                </div>
              ))}
          </div>
        </SectionContainer>
        <SectionContainer grey>
          <div className="row">
            <div className="col-md-12 g-mb-60">
              <div className="g-mt-50 text-center text-uppercase u-heading-v6-1 g-mb-20">
                <h2 className="h3 u-heading-v6__title">Características de Nuestros Hosting</h2>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 g-mb-60 g-mt-60">
              <div
                style={{ height: '100%' }}
                className="g-bg-white u-shadow-v21 g-brd-around--md g-brd-gray-light-v4 text-center g-px-30 g-pb-20">
                <span
                  style={{ height: 110, width: 110 }}
                  className="u-icon-v3 g-color-white g-pull-50x-up rounded-circle">
                  <img src={settings} className="icon-block-image-45"></img>
                </span>
                <h3 className="h5 g-mb-30 g-font-size-25" style={{ marginTop: -20 }}>
                  Panel de Control
                </h3>
                <p className="g-mb-20">
                  Administra de forma fácil tu servicio web hosting con el panel de control cPanel.
                </p>
              </div>
            </div>
            <div className="col-lg-4 g-mb-60 g-mt-60">
              <div
                style={{ height: '100%' }}
                className="g-bg-white u-shadow-v21 g-brd-around--md g-brd-gray-light-v4 text-center g-px-30 g-pb-20">
                <span
                  style={{ height: 110, width: 110 }}
                  className="u-icon-v3 g-color-white g-pull-50x-up rounded-circle">
                  <img src={firewall} className="icon-block-image-45"></img>
                </span>
                <h3 className="h5 g-mb-30 g-font-size-25" style={{ marginTop: -20 }}>
                  Firewall
                </h3>
                <p className="g-mb-20">
                  Detenemos múltiples ataques a diario, siéntete seguro, nuestro firewall protege
                  nuestros servidores.
                </p>
              </div>
            </div>

            <div className="col-lg-4 g-mb-60 g-mt-60">
              <div
                style={{ height: '100%' }}
                className="g-bg-white u-shadow-v21 g-brd-around--md g-brd-gray-light-v4 text-center g-px-30 g-pb-20">
                <span
                  style={{ height: 110, width: 110 }}
                  className="u-icon-v3 g-color-white g-pull-50x-up rounded-circle">
                  <img src={lock} className="icon-block-image-45"></img>
                </span>
                <h3 className="h5 g-mb-30 g-font-size-25" style={{ marginTop: -20 }}>
                  Certificado SSL
                </h3>
                <p className="g-mb-20">
                  Bríndales seguridad a tus visitantes, todos nuestros planes hosting incluyen
                  Certificado SSL.
                </p>
              </div>
            </div>

            <div className="col-lg-4 g-mb-60 g-mt-60">
              <div
                style={{ height: '100%' }}
                className="g-bg-white u-shadow-v21 g-brd-around--md g-brd-gray-light-v4 text-center g-px-30 g-pb-20">
                <span
                  style={{ height: 110, width: 110 }}
                  className="u-icon-v3 g-color-white g-pull-50x-up rounded-circle">
                  <img src={php} className="icon-block-image-45"></img>
                </span>
                <h3 className="h5 g-mb-30 g-font-size-25" style={{ marginTop: -20 }}>
                  Versiones de PHP
                </h3>
                <p className="g-mb-20">
                  Obten más performance y velocidad con la ultima versión de PHP o elige la versión
                  compatible con tu sitio.
                </p>
              </div>
            </div>

            <div className="col-lg-4 g-mb-60 g-mt-60">
              <div
                style={{ height: '100%' }}
                className="g-bg-white u-shadow-v21 g-brd-around--md g-brd-gray-light-v4 text-center g-px-30 g-pb-20">
                <span
                  style={{ height: 110, width: 110 }}
                  className="u-icon-v3 g-color-white g-pull-50x-up rounded-circle">
                  <img src={backup} className="icon-block-image-45"></img>
                </span>
                <h3 className="h5 g-mb-30 g-font-size-25" style={{ marginTop: -20 }}>
                  Respaldo Diario
                </h3>
                <p className="g-mb-20">
                  Realizamos copias de seguridad a diario en 2 Datacenter distintos.
                </p>
              </div>
            </div>

            <div className="col-lg-4 g-mb-60 g-mt-60">
              <div
                style={{ height: '100%' }}
                className="g-bg-white u-shadow-v21 g-brd-around--md g-brd-gray-light-v4 text-center g-px-30 g-pb-20">
                <span
                  style={{ height: 110, width: 110 }}
                  className="u-icon-v3 g-color-white g-pull-50x-up rounded-circle">
                  <img src={monitor} className="icon-block-image-45"></img>
                </span>
                <h3 className="h5 g-mb-30 g-font-size-25" style={{ marginTop: -20 }}>
                  Monitoreo
                </h3>
                <p className="g-mb-20">
                  Monitoreamos cada segundo el estado de nuestros servidores, así podremos tener una
                  respuesta inmediata ante cualquier eventualidad.
                </p>
              </div>
            </div>
          </div>
        </SectionContainer>
        <HostingInfo data={this.state.hostingInfo} />
        <FormularioContactoModal asunto={this.state.modalAsunto} />
      </Section>
    );
  }
}

export default HostingEnterprise;



// WEBPACK FOOTER //
// ./src/sections/datacenter/HostingEnterprise.js